// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ring-save-field{font-size:0;line-height:0;display:inline-block}.ring-save-field .ring-save-field__button{margin-left:8px;vertical-align:top}", ""]);
// Exports
module.exports = exports;
